import { VaerifyUser } from '@/shared/models/VaerifyUser'
import { SoMeUser } from '@/shared/models/SoMeUser'
import { Toast, ToastPayload, createToast, defaultTimeout } from '@/shared/models/Toast'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    vaerifyUser: new VaerifyUser(),
    isRoomService: false,
    countryCodes: null,
    facebookUser: new SoMeUser(),
    appleUser: new SoMeUser(),
    toasts: [] as Array<Toast>,
    checkInSuccessToastShown: false
  },
  mutations: {
    addToast (state, toast: Toast) {
      state.toasts.push(toast)
    }
  },
  actions: {
    toastUpdate ({ commit }, { toastPayload, toastStatus }) {
      const toast = createToast(toastStatus, toastPayload.title, toastPayload.description)
      commit('addToast', toast)
      setTimeout(() => {
        this.state.toasts = this.state.toasts.filter((t) => t.id !== toast.id)
      }, toastPayload.timeout ?? defaultTimeout)
    },
    toastInfo ({ dispatch }, payload: ToastPayload) {
      dispatch('toastUpdate', { toastPayload: payload, toastStatus: 'info' })
    },
    toastSuccess ({ dispatch }, payload: ToastPayload) {
      dispatch('toastUpdate', { toastPayload: payload, toastStatus: 'success' })
    },
    toastWarning ({ dispatch }, payload: ToastPayload) {
      dispatch('toastUpdate', { toastPayload: payload, toastStatus: 'warning' })
    },
    toastError ({ dispatch }, payload: ToastPayload) {
      dispatch('toastUpdate', { toastPayload: payload, toastStatus: 'error' })
    }
  },
  modules: {
  }
})
